import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';
import logger from 'src/utils/logger';

function VergiDairesiSearch({ setVergiDairesi, value, searchParam }) {
    const [openVD, setOpenVD] = React.useState(false);
    const [optionsVD, setOptionsVD] = React.useState([]);
    const loadingVD = openVD && optionsVD.length === 0;
    const [searchVD, setSearchVD] = React.useState('');

    React.useEffect(() => {
        if (searchVD.length > 0 && (openVD)) {
            axios.get('/GetArtemisVergiDairesi/' + searchVD.toString().toLocaleLowerCase('tr-TR'))
                .then(res => {
                    const responseVD = res.data;
                    if (responseVD.length > 0) {
                        setOptionsVD(responseVD);
                    } else {
                       setOptionsVD([]);
                    }
                }).catch(error => {
                    setOptionsVD([]);
                    logger.error("Hata detayı:", error.message);
                });
        }
    }, [searchVD, openVD, loadingVD]);

    React.useEffect(() => {
        if (searchParam.length > 0) {
            setSearchVD(searchParam);
        }
    }, [searchParam]);

    const updateVergiDairesi = vd => {
        setVergiDairesi(vd);
        value.ACIKLAMA = vd.ACIKLAMA;
        value.KOD = vd.KOD;
    }

    return (
        <Autocomplete
            id="asynchronous-demo"
            open={openVD}
            value={value}
            onOpen={() => {
                setOpenVD(true);
            }}
            onClose={() => {
                setOpenVD(false);
            }}
            getOptionLabel={(option) => { return option.KOD ? (option.KOD + ' - ' + option.ACIKLAMA) : '-' }}
            options={optionsVD}
            filterOptions={(optionsVD) => optionsVD}
            loading={loadingVD}
            onChange={(event, newValueVD) => {
                if (newValueVD && newValueVD.ACIKLAMA) {
                    updateVergiDairesi(newValueVD);
                }
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    onChange={e => { setSearchVD(e.target.value) }}
                    variant="outlined"
                    helperText={value ? value.ACIKLAMA : ''}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loadingVD ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}

export default VergiDairesiSearch;
